import { useState, useMemo, useContext } from "react";
import { MobXProviderContext } from "mobx-react";
import { BettingZoneMenuItemModel } from "./models/betting-zone.menu-item.model";
import { BettingContainerState } from "../../models/betting-container.state";

export const useBettingZoneNavigation = (controller, initialSelectedId = null, duplicateParent = false) => {
  const [selectedId, setSelectedId] = useState(initialSelectedId);
  const { ioc } = useContext(MobXProviderContext);
  const bettingContainerState: BettingContainerState = ioc?.getInstance(BettingContainerState);
  const menuItems = bettingContainerState?.dataSource?.mainMenu;

  const { lookupMap, rootItems } = useMemo(() => {
    const map = new Map();
    const roots = [];

    if (!menuItems) return { lookupMap: map, rootItems: roots };

    const processItem = (item) => {
      map.set(item.id, item);
      if (item.items && item.items.length > 0) {
        item.items.forEach(processItem);

        if (duplicateParent) {
          const headerClone = Object.assign(Object.create(Object.getPrototypeOf(item)), item);
          if (item.linkLabel) headerClone.label = item.linkLabel;
          headerClone.items = null;
          item.items = [headerClone, ...item.items];
        }
      }
    };

    menuItems.forEach((data) => {
      const model = new BettingZoneMenuItemModel(data, null);
      roots.push(model);
      processItem(model);
    });

    return { lookupMap: map, rootItems: roots };
  }, [menuItems, duplicateParent]);

  const selectedItem = selectedId ? lookupMap.get(selectedId) || null : null;
  const activeItems = selectedId ? (selectedItem?.items || []) : rootItems;

  const navigate = (id) => {
    if (id === -1) {
      setSelectedId(selectedItem?.parentId || null);
    } else {
      const targetItem = lookupMap.get(id);
      if (targetItem?.hasItems) {
        setSelectedId(id);
      }
    }
  };

  return {
    selectedItem,
    activeItems,
    navigate,
    isLoading: !menuItems
  };
};